import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import * as App from 'modules/app/App';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import { ReviewType, QueueType } from 'areas/shared/consts';
import ApprovalReviewPopUp from './ApprovalReviewPopUp';
import * as Notifications from 'fw/globals/Notifications';
import AppealRequestPopUp from 'areas/shared/modals/AppealRequestPopUp/AppealRequestPopUp';
import { ReviewHelpers } from 'areas/shared/helpers';
import DenialConfirmationPopUp from 'areas/admin/certification/shared/DenialConfirmationPopUp';
import DenialCodesPopUp from 'areas/admin/certification/shared/DenialCodesPopUp';

class FinalReview extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            showApprovalReviewPopUp: false,
			showAppealRequestPopUp: false,
			showAppealAcceptPopUp: false,
			showAppealRejectPopUp: false,
			showDenialConfirmation: false,
			showDenialCodesPopUp: false,
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminFinalReviewAccess"),
            edit: App.hasPrivilege("AdminFinalReviewAccess")
        }
    }

    isEnabled(data) {
        return (!data.isReviewFinished && this.props.queueTypeCode === "FIN") || App.hasPrivilege("AdminFullEditAccess");
    }

    urls() {
        return {
            completeCertification: APIRoutes.Admin.url("/finalReview/approveCertification"),
            denyCertification: APIRoutes.Admin.url("/finalReview/denyCertification"),
			appealCertification: APIRoutes.Admin.url("/certification/appealRequest"),
			approveAppeal: APIRoutes.Admin.url("/finalReview/approveAppeal"),
            rejectAppeal: APIRoutes.Admin.url("/finalReview/rejectAppeal"),
            get: APIRoutes.Admin.url('/finalReview/getFinalReviewInfo'),
            loadComments: APIRoutes.Admin.url("/appReview/getComments"),
            save: APIRoutes.Admin.url('/finalReview/save')
        }
    }

    loadComments = () => {
        let rq = {
            certificationId: this.state.form.certificationId,
            queueTypeCode: QueueType.FINAL_REVIEW.code,
        };

        new API().get(this.urls().loadComments, rq,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.comments = r.data.comments;
                    form.canCompleteReview = r.data.canCompleteReview;

                    this.setState(form);
                }
            });
    }

    handleCommentsGrid = (comments) => {
        this.setState({ reviewComment: '' });
        this.handleUpdateComments(comments, true);
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            content: this.state.reviewComment
        }
    }

    completeCertificationReviewRequest(rq) {
        return {
            entityKey: this.props.selectedId,
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            rowVersion: this.state.form.rowVersion,
            reviewComment: this.state.reviewComment,
            reviewTypeCode: 'FNR',
            reviewQueueTypeCode: 'FIN',
            approvalDate: rq !== undefined ? rq.approvalDate : null,
            serviceDisabled: rq !== undefined ? rq.serviceDisabled : null,
            // Denial code fields
            denialCode1Id: rq !== undefined ? rq.denialCode1Id : null,
            denialCode2Id: rq !== undefined ? rq.denialCode2Id : null,
            denialCode3Id: rq !== undefined ? rq.denialCode3Id : null,
            applicationDays: rq !== undefined ? rq.applicationDays : null,
            isRefunded: rq !== undefined ? rq.isRefunded : null
        }
    }

    openConfirmationPopUp = () => {
        this.setState({
            showApprovalReviewPopUp: true
        });
    }

	openAppealRequestPopUp = () => {
		this.setState({
			showAppealRequestPopUp: true
		});
	}

	openAppealAcceptPopUp = () => {
		this.setState({
			showAppealAcceptPopUp: true
		});
	}

	openAppealRejectPopUp = () => {
		this.setState({
			showAppealRejectPopUp: true
		});
	}

    handleApproveCertification = (data) => {
        var rq = {
            approvalDate: data.approvalDate,
            serviceDisabled: data.disabledVobStatus
        };
        const me = this;

        this.setState({
            showApprovalReviewPopUp: false
        }, () => {
            this.beforeSave(() => {
                me.approveCertification(rq);
            });
        });
    }

	handleRequestAppeal = (data) => {
		var rq = {
			certificationId: data.certificationId,
			appealReason: data.appealReason
		}
		
		var url = this.urls().appealCertification

        this.setState({
            saving: true,
			showAppealRequestPopUp: false,
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;
					Notifications.success(r.message);
                    this.setState({
                        saving: false,
                        form: { ...form, isAppealed: true, hasOpenAppeal: true }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });
                },
                error: r => {
                    this.setState({ saving: false });
                    this.props.onError(r.error);
					Notifications.error(r.error);
                }
            })
        });
	}

	handleAcceptAppeal = (data) => {
		var rq = {
			certificationId: data.certificationId,
			acceptanceReason: data.appealReason
		}
		
		var url = this.urls().approveAppeal

        this.setState({
            saving: true,
			showAppealAcceptPopUp: false,
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;
					Notifications.success(r.message);
                    this.setState({
                        saving: false,
                        form: { ...form, hasOpenAppeal: false }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });
                },
                error: r => {
                    this.setState({ saving: false });
                    this.props.onError(r.error);
					Notifications.error(r.error);
                }
            })
        });
	}

	handleRejectAppeal = (data) => {
		var rq = {
			certificationId: data.certificationId,
			rejectionReason: data.appealReason
		}
		
		var url = this.urls().rejectAppeal

        this.setState({
            saving: true,
			showAppealRejectPopUp: false,
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;
					Notifications.success(r.message);
                    this.setState({
                        saving: false,
                        form: { ...form, hasOpenAppeal: false }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });
                },
                error: r => {
                    this.setState({ saving: false });
                    this.props.onError(r.error);
					Notifications.error(r.error);
                }
            })
        });
	}

    onApprovalReviewPopUpClose = () => {
        this.setState({
            showApprovalReviewPopUp: false
        });
    }

	onAppealRequestPopUpClose = () => {
		this.setState({
            showAppealRequestPopUp: false
        });
	}

	onAppealAcceptPopUpClose = () => {
		this.setState({
            showAppealAcceptPopUp: false
        });
	}

	onAppealRejectPopUpClose = () => {
		this.setState({
            showAppealRejectPopUp: false
        });
	}

    confirmDenyCertification = () => {
        this.setState({ showDenialConfirmation: true });
    }

	onDenialConfirmationCancel = () => {
		this.setState({ showDenialConfirmation: false });
	}

	onDenialConfirmationProceed = () => {
		this.setState({
			showDenialConfirmation: false,
			showDenialCodesPopUp: true
		});
	}

	onDenialCodesCancel = () => {
		this.setState({ showDenialCodesPopUp: false });
	}

	onDenialCodesSave = (denialData) => {
		this.setState({ showDenialCodesPopUp: false });
		const me = this;
		this.beforeSave(() => {
			me.denyCertification(denialData);
		});
	}

    handleDenyCertification = (customRq) => {
        const me = this;
        this.beforeSave(() => {
            me.denyCertification(customRq);
        });
    }

    approveCertification = (customRq) => {
        this.completeAllReviews(true, customRq);
    }

    denyCertification = (customRq) => {
        this.completeAllReviews(false, customRq);
    }

    handleAppReviewToolbar = (comments, canCompleteReview) => {
        this.handleUpdateComments(comments, canCompleteReview);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments, canCompleteReview) {
        let form = this.state.form;

        form.comments = comments;
        form.isFlagged = !canCompleteReview;

        this.setState(form);
    }

    openEmailDialog = () => {
        let to = this.state.form.primaryContactEmail;
        let subject = "VOCS - Certification Denied";
        let message = this.state.form.requestConnectionTemplateBody;

        this.setState({
            emailDialog: true,
            emailDialogTo: to,
            emailDialogSubject: subject,
            emailDialogMessage: message
        });
    }

    closeEmailDialog = () => {
        this.setState({
            emailDialog: false
        });
    }

    completeAllReviews = (isApproved, customRq) => {
        // Proceed
        const me = this;
        let url = "";
        let rq = {};

        if (isApproved)
            url = this.urls().completeCertification;
        else
            url = this.urls().denyCertification;

        rq = this.completeCertificationReviewRequest(customRq);

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;

                    this.setState({
                        saving: false,
                        dirty: false,
                        form: { ...form, isReviewFinished: true }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                    this.afterSave(r.data.entityId);
                    this.props.onSuccess(r.message);
                    this.props.onSave(r.data.entityId);
                    FormManager.reset();
                },
                error: r => {
                    me.setState({ saving: false });
                    this.props.onError(r.error);
                }
            })
        });
    }

    ready = () => {
        if (!this.state.form.queueAssigned)
            Notifications.error("Final Review is currently unassigned.");
        this.focusControl && this.focusControl.focus();
    }

    afterSave = (entityId) => {
        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });
    }

    renderButtons = () => {
        if (!this.state.form.queueAssigned)
            return null;	
					
        return (
            <React.Fragment>
                <hr />
                {ReviewHelpers.renderFinalDenialEmailDialog(this.state, this.closeEmailDialog, this.handleDenyCertification)}
                <Row>
                    <Col md={2}>
						{this.state.form.certificationStatus === "Denied"
						&& !this.state.form.isAppealed &&
							<Button bsStyle="primary" className="btn-block" onClick={this.openAppealRequestPopUp}>
								Appeal Certification
							</Button>
						}
						<AppealRequestPopUp
                            certificationId={this.state.form.certificationId}
							header="Appeal Reason"
							label="Enter a reason for this appeal"
							visible={this.state.showAppealRequestPopUp}
							onClose={this.onAppealRequestPopUpClose}
							onConfirm={this.handleRequestAppeal}
						/>
					</Col>
					<Col md={2}>
						{this.state.form.hasOpenAppeal &&
							<React.Fragment>
								<Button bsStyle="danger" className="btn-block" onClick={this.openAppealRejectPopUp}>
									Reject Appeal
								</Button>
								<AppealRequestPopUp
									certificationId={this.state.form.certificationId}
									header="Appeal Rejection Reason"
									label="Enter the rejection reason for this appeal"
									visible={this.state.showAppealRejectPopUp}
									onClose={this.onAppealRejectPopUpClose}
									onConfirm={this.handleRejectAppeal}
								/>
							</React.Fragment>
						}
					</Col>
					<Col md={2}>
						{this.state.form.hasOpenAppeal && 
							<React.Fragment>
								<Button bsStyle="primary" className="btn-block" onClick={this.openAppealAcceptPopUp}>
									Accept Appeal
								</Button>
								<AppealRequestPopUp
									certificationId={this.state.form.certificationId}
									header="Appeal Acceptance Reason"
									label="Enter the acceptance reason for this appeal"
									visible={this.state.showAppealAcceptPopUp}
									onClose={this.onAppealAcceptPopUpClose}
									onConfirm={this.handleAcceptAppeal}
								/>
							</React.Fragment>
						}
					</Col>
                    <Col md={2}>
                        <AppReviewToolbar
                            disabled={this.state.form.isReviewFinished}
                            certificationKey={this.props.selectedId}
                            comments={this.state.form.comments}
                            onFlagSave={this.handleAppReviewToolbar}
                            queueTypeCode={"FIN"}
                            reviewTypeCode={'FNR'}
                        />
                    </Col>
                    <Col md={2}>
                        <Button bsStyle="default" className="btn-block" onClick={this.confirmDenyCertification}
                            disabled={this.state.form.isReviewFinished}>Deny Certification</Button>
                        <DenialConfirmationPopUp
                            visible={this.state.showDenialConfirmation}
                            onCancel={this.onDenialConfirmationCancel}
                            onDenialCodes={this.onDenialConfirmationProceed}
                        />
                        <DenialCodesPopUp
                            visible={this.state.showDenialCodesPopUp}
                            certificationId={this.state.form.certificationId}
                            onCancel={this.onDenialCodesCancel}
                            onSave={this.onDenialCodesSave}
                        />
                    </Col>
                    <Col md={2}>
                        <Button bsStyle="primary" className="btn-block" onClick={this.openConfirmationPopUp}
                            disabled={this.state.form.isReviewFinished || this.state.form.isFlagged}>Approve Certification</Button>
                        <ApprovalReviewPopUp
                            onConfirm={this.handleApproveCertification}
                            certificationId={this.state.form.certificationId}
                            visible={this.state.showApprovalReviewPopUp}
                            onClose={this.onApprovalReviewPopUpClose}>
                        </ApprovalReviewPopUp>
                    </Col>
                </Row>
                <hr style={{ marginTop: 5, marginBottom: 5 }} />
                <Row>
                    <Col md={12}>
                        {ReviewHelpers.renderAdminStepToolbar(ReviewType.FINAL_REVIEW.code, QueueType.FINAL_REVIEW.code, this.state.form, this.props, this._ast )}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Final Review
                                    {ReviewHelpers.renderAdminStepToolbar(ReviewType.FINAL_REVIEW.code, QueueType.FINAL_REVIEW.code, this.state.form, this.props, this._ast )}
                                </h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <hr />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"FNR"}
                        queueTypeCode={"FIN"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled || !this.state.form.queueAssigned}
                        commentSectionTitle={"Final Review Comments - "}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                        showAddButton={true}
                    />
                </Row>
            </React.Fragment>
        )
    }
}

export default FinalReview;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/finalReview/FinalReview.js